import WordGuessPuzzleConfig from '../interfaces/word-guess-puzzle.config';
import {
  WORD_GUESS_DEFAULT_MAX_GUESSES,
  WORD_GUESS_DEFAULT_WORD_LENGTH,
  normalizeWordGuessWord,
} from '../logic/word-guess-alphabet';

export interface WordGuessPuzzle {
  puzzleID: string;
  solution: string;
  solutionOriginal?: string;
  wordLength: number;
  maxGuesses: number;
}

function parsePositiveInt(raw: string | undefined, fallback: number): number {
  const value = parseInt(raw, 10);

  return Number.isFinite(value) && value > 0 ? value : fallback;
}

/*
 * Turns the parsed puzzle file into the model the board works with.
 *
 * Throws when the file carries no usable solution word — the board has nothing to show in
 * that case, and a silent empty grid would be much harder to diagnose.
 */
export function adaptWordGuessPuzzleConfig(config: WordGuessPuzzleConfig): WordGuessPuzzle {
  const solution = normalizeWordGuessWord(config?.game?.solution?._word);

  if (!solution.length) {
    throw new Error('Word Guess puzzle file has no solution word');
  }

  const wordLength = parsePositiveInt(config._colCount, solution.length || WORD_GUESS_DEFAULT_WORD_LENGTH);

  if (wordLength !== solution.length) {
    throw new Error(
      `Word Guess solution "${solution}" has ${solution.length} letters but colCount is ${wordLength}. ` +
        'Note that ß is not supported and must be written as SS.'
    );
  }

  return {
    puzzleID: config._id,
    solution,
    solutionOriginal: config.game.solution._original,
    wordLength,
    maxGuesses: parsePositiveInt(config._rowCount, WORD_GUESS_DEFAULT_MAX_GUESSES),
  };
}
